let Hooks = {};

Hooks.PinoutDiagram = {
  mounted() {
    const table = this.el;
    const container = document.createElement("div");
    container.className = "rj45-container";

    const svgNS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("viewBox", "0 0 140 235");
    svg.setAttribute("class", "rj45-diagram");

    svg.innerHTML = this.rj45SVG();

    // Insert the container before the table
    table.parentNode.insertBefore(container, table);

    // Move the table into the container
    container.appendChild(svg);
    container.appendChild(table);

    // Add hover event listeners to table rows
    const rows = table.querySelectorAll("tr");
    rows.forEach((row, index) => {
      const pinNumber = index + 1;

      row.addEventListener("mouseenter", () => {
        this.highlightPin(svg, table, pinNumber, true);
      });

      row.addEventListener("mouseleave", () => {
        this.highlightPin(svg, table, pinNumber, false);
      });
    });

    // Add hover event listeners to SVG pins
    for (let i = 1; i <= 8; i++) {
      const pinElement = svg.querySelector(`.pin-${i}`);
      const pinPlateElement = svg.querySelector(`.pin-${i}-plate`);

      if (pinElement) {
        pinElement.addEventListener("mouseenter", () => {
          this.highlightPin(svg, table, i, true);
        });

        pinElement.addEventListener("mouseleave", () => {
          this.highlightPin(svg, table, i, false);
        });
      }

      if (pinPlateElement) {
        pinPlateElement.addEventListener("mouseenter", () => {
          this.highlightPin(svg, table, i, true);
        });

        pinPlateElement.addEventListener("mouseleave", () => {
          this.highlightPin(svg, table, i, false);
        });
      }
    }
  },

  highlightPin(svg, table, pinNumber, highlight) {
    const row = table.querySelectorAll("tr")[pinNumber - 1];
    const pinElement = svg.querySelector(`.pin-${pinNumber}`);
    const pinPlateElement = svg.querySelector(`.pin-${pinNumber}-plate`);

    if (highlight) {
      if (row) row.classList.add("row-highlighted");
      if (pinElement) pinElement.classList.add("pin-highlighted");
      if (pinPlateElement) pinPlateElement.classList.add("pin-highlighted");
    } else {
      if (row) row.classList.remove("row-highlighted");
      if (pinElement) pinElement.classList.remove("pin-highlighted");
      if (pinPlateElement) pinPlateElement.classList.remove("pin-highlighted");
    }
  },

  rj45SVG() {
    return `
      <defs>
        <!-- Stripe patterns for twisted pairs -->
        <pattern id="stripe-orange" patternUnits="userSpaceOnUse" width="20" height="20" patternTransform="rotate(45)">
          <rect width="10" height="20" fill="#ff8c00"/>
          <rect x="10" width="10" height="20" fill="#fff"/>
        </pattern>
        <pattern id="stripe-green" patternUnits="userSpaceOnUse" width="20" height="20" patternTransform="rotate(45)">
          <rect width="10" height="20" fill="#32cd32"/>
          <rect x="10" width="10" height="20" fill="#fff"/>
        </pattern>
        <pattern id="stripe-blue" patternUnits="userSpaceOnUse" width="20" height="20" patternTransform="rotate(45)">
          <rect width="10" height="20" fill="#1e90ff"/>
          <rect x="10" width="10" height="20" fill="#fff"/>
        </pattern>
        <pattern id="stripe-brown" patternUnits="userSpaceOnUse" width="20" height="20" patternTransform="rotate(45)">
          <rect width="10" height="20" fill="#8b4513"/>
          <rect x="10" width="10" height="20" fill="#fff"/>
        </pattern>
      </defs>

      <path class="outline" d="M 8 20 L 136 20 L 136 180 L 126 190 L 20 190 L 8 180 Z"/>
      <rect class="tab" x="35" y="13" width="70" height="5"/>

      <rect class="pin-1-plate" x="18" y="18" width="10" height="32"/>
      <rect class="pin-1" x="18" y="50" width="10" height="70"/>
      <text class="pin-text" x="23" y="10">1</text>

      <rect class="pin-2-plate" x="32" y="18" width="10" height="32"/>
      <rect class="pin-2" x="32" y="50" width="10" height="70"/>
      <text class="pin-text" x="37" y="10">2</text>

      <rect class="pin-3-plate" x="46" y="18" width="10" height="32"/>
      <rect class="pin-3" x="46" y="50" width="10" height="70"/>
      <text class="pin-text" x="51" y="10">3</text>

      <rect class="pin-4-plate" x="60" y="18" width="10" height="32"/>
      <rect class="pin-4" x="60" y="50" width="10" height="70"/>
      <text class="pin-text" x="65" y="10">4</text>

      <rect class="pin-5-plate" x="74" y="18" width="10" height="32"/>
      <rect class="pin-5" x="74" y="50" width="10" height="70"/>
      <text class="pin-text" x="79" y="10">5</text>

      <rect class="pin-6-plate" x="88" y="18" width="10" height="32"/>
      <rect class="pin-6" x="88" y="50" width="10" height="70"/>
      <text class="pin-text" x="93" y="10">6</text>

      <rect class="pin-7-plate" x="102" y="18" width="10" height="32"/>
      <rect class="pin-7" x="102" y="50" width="10" height="70"/>
      <text class="pin-text" x="107" y="10">7</text>

      <rect class="pin-8-plate" x="116" y="18" width="10" height="32"/>
      <rect class="pin-8" x="116" y="50" width="10" height="70"/>
      <text class="pin-text" x="121" y="10">8</text>

      <!-- Cable shielding (extends beyond connector) -->
      <rect class="cable" x="35" y="130" width="74" height="80"/>
      <rect class="crimp" x="18" y="125" width="108" height="30"/>
      <text class="caption" x="72" y="230">RJ45</text>
    `;
  },
};

export { Hooks };
